import type { FC } from 'react';
import type { ProjectCardProps } from '../components/ProjectCard';
import React from 'react';
import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Typography
} from '@mui/material';
import { Masonry } from '@mui/lab';
import AppBar from '../components/AppBar';
import ProjectCard from '../components/ProjectCard';


const cards: ProjectCardProps[] = [
  {
    title: 'Wowks in Pwogwess',
    body: 'A monthly script workshop for screenwriters and/or playwrights presenting works in progress',
    href: '/projects/wip',
    src: '/static/wip.jpg',
  },
  {
    title: 'Found Cassettes',
    body: 'A horror podcast anthology series made from writer-submitted scripts',
    href: '/projects/found-cassettes',
    src: '/static/found-cassettes.jpg',
  },
  {
    title: 'rEMOTION 2021',
    body: 'An online charity theatre festival centering on global Asian diaspora',
    href: '/projects/remotion-2021',
    src: '/static/remotion-2021.jpg',
  },
  {
    title: 'Tales from the Visa Line 2020',
    body: 'An online charity theatre festival benefitting the International Refugee Assistance Project',
    href: '/projects/tales-from-the-visa-line-2020',
    src: '/static/tales-2020.png',
  },
  {
    title: 'untitled [redacted]',
    body: 'A surreal horror audio drama/podcast',
    href: '/projects/untitled-redacted',
    src: '/static/untitled-redacted.jpg',
  },
  {
    title: 'rEMOTION 2020',
    body: 'An online charity theatre festival centering on global Asian diaspora',
    href: 'http://remotionfestival.com/remotion2020',
    src: '/static/remotion-2020.jpg',
  },
];

const About: FC = () => {
  return (
    <Box>
      <Helmet title="Projects | Scawwy Howwow Theatre, Inc." />
      <AppBar />
      <Container
        maxWidth="xl"
        sx={{ my: 6 }}
      >
        <Typography variant="h1">
          Projects
        </Typography>
        <Masonry columns={{ xs: 1, sm: 2, lg: 3 }} spacing={3}>
          {cards.map((card) => (
            <ProjectCard {...card} />
          ))}
        </Masonry>
      </Container>
    </Box>
  );
};

export default About;
